const services = [
  {
    "id": 1,
    "image_url": "https://www.hostinger.com.br/tutoriais/wp-content/uploads/sites/12/2020/05/Sites-Para-Designers.webp",
    "name": "Design de Sites",
    "description": "Criação de sites modernos e responsivos."
  },
  {
    "id": 2,
    "image_url": "https://www.actwork.com.br/blog/wp-content/uploads/marketing-digital-para-investir.jpg",
    "name": "Marketing Digital",
    "description": "Campanhas de marketing para aumentar sua presença online."
  },
  {
    "id": 3,
    "image_url": "https://mediamanager.com.br/wp-content/uploads/2023/04/seo-guia-completo-de-otimizacao-de-sites.png.webp",
    "name": "Otimização SEO",
    "description": "Aprimoramento de sites para melhores resultados nos mecanismos de busca."
  },
  {
    "id": 4,
    "image_url": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_3yYZl8beGvSIHqVYIfq36wuDkT47xiFGVQ&s",
    "name": "Desenvolvimento de Apps",
    "description": "Criação de aplicativos móveis personalizados para Android e iOS."
  },
  {
    "id": 5,
    "image_url": "https://ied.edu.br/news/19019/image-thumb__19019__scaleByWidth1000/Design%20Gr%C3%A1fico%20e%20Digital%20do%20IED%20SP_1.png",
    "name": "Design Gráfico",
    "description": "Design de peças gráficas criativas para diversas mídias."
  }
]

export default services;